import React from 'react';
import { Crown, Zap } from 'lucide-react';
import { TRANSLATIONS } from '../../translations';
import { GEMINI_CONFIG } from '@/core/apiConfig';

interface AccountStatusProps {
  isPro: boolean;
  guestGenerations: number;
  language: 'en' | 'pl';
}

export const AccountStatus: React.FC<AccountStatusProps> = ({ isPro, guestGenerations, language }) => {
  const t = TRANSLATIONS[language];

  return (
    <div
      className="fixed top-4 right-4 bg-gradient-to-br from-gray-800 to-gray-900 text-white p-3 rounded-full shadow-lg flex items-center space-x-2 border border-gray-700 backdrop-filter backdrop-blur-lg bg-opacity-30 z-50"
      data-testid="account-status"
      data-plan={isPro ? 'pro' : 'free'}
    >
      {isPro ? (
        <>
          <Crown className="w-5 h-5 text-yellow-400" />
          <span className="text-sm font-semibold">{t.planPro}</span>
        </>
      ) : (
        <>
          <Zap className="w-5 h-5 text-blue-400" />
          <span className="text-sm font-semibold">{t.planFree} ({guestGenerations}/{GEMINI_CONFIG.GUEST_GENERATION_LIMIT} {t.uses})</span>
        </>
      )}
    </div>
  );
};